// @flow
import React from 'react';
import ClientContext from './ClientContext';
import {setDisplayName, wrapDisplayName, type HOC} from 'recompose';
import type { ClientType } from './flowTypes';

export type SetRedirect = (path: string) => void;

type ClientProps = {
  clientPromise: Promise<ClientType>,
}

function withClient<Props: {}>(): HOC<{ ...$Exact<Props>, ...ClientProps }, Props>{
  return (BaseComponent) => {
    function WithClient(props: Props) {
      return (
        <ClientContext.Consumer>
          {clientPromise => <BaseComponent {...props} clientPromise={clientPromise} />}
        </ClientContext.Consumer>
      );
    };

    if(process.env.NODE_ENV !== 'production') {
      return setDisplayName(
        wrapDisplayName(BaseComponent, 'withClient')
      )(WithClient);
    }
   
    return WithClient;
  };
};

export default withClient;



// WEBPACK FOOTER //
// ./src/application/client/withClient.js